<template>
    <div class="event-ticket-mode--view">
        <div class="event-ticket--title">
            <h5 class="card-title h5-responsive mb-0">
                <span>{{langData(ticket,'title')}} {{ticket.id}}</span>
            </h5>
            <section data-open-close-time>
                <i class="fa fa-clock"/>
                <span>{{methods_available.readEventTicketAttribute(ticket,'open_close_full',['open_time','value'],
                          ['ticket_data','entity_type_data','entity_type_fields','groups','open_close_full','items','open_time','value']
                          )}}
                    </span>
                -
                <span>
                        {{methods_available.readEventTicketAttribute(ticket,'open_close_full',['close_time','value'],
                        ['ticket_data','entity_type_data','entity_type_fields','groups','open_close_full','items','close_time','value']
                        )}}
                    </span>
            </section>
        </div>
        <div class="d-flex justify-content-between align-content-center">
            <div class="event-ticket--price">
                <p class="mb-1">Current Price</p>
                <h4>{{formatPrice(ticket.price)}}</h4>
            </div>
            <div class="event-ticket--sales">
                <p class="mb-1">SALES</p>
                <h4 v-html="methods_available.readEarnings(ticket)"></h4>
            </div>
        </div>
        <!--stats-->
        <div class="text-center d-flex justify-content-md-between pt-2 pb-2">
            <div v-if="layout.current === 'list'">
                <!--<span>Price: </span><span v-html="createMoney(ticket.price)"></span>-->
            </div>
            <BaseBadge
                class="event-ticket-allocated"
                title="Used"
                cls="badge-secondary"
            >
                {{readUsed(ticket)}}
            </BaseBadge>
            <BaseBadge
                class="event-ticket-allocated"
                title="Allocated"
            >
                {{ticket.allocated}}
            </BaseBadge>
            <BaseBadge
                class="event-ticket-remaining"
                title="Remaining"
            >
                {{readAvailable(ticket)}}
            </BaseBadge>
        </div>
    </div>
</template>

<script>
    import {format} from "../../../../../../app/Shared/Resources/Assets/js/helpers/money";

    export default {
        name: 'event-ticket-mode-view',
        props: [
            'ticket',
            'layout',
            'methods_available',
            'lang'
        ],
        mounted() {

        },
        data() {
            return {};
        },
        methods: {
            formatPrice(value){
                return format(value)
            },
            langData(ticket, id) {
                return ticket.ticket_data.lang[this.lang][id];
            },
            readAvailable(ticket) {
                let alloc = ticket.allocated,
                    used = this.readUsed(ticket);

                return alloc - used;
            },
            readUsed(ticket) {
                let count = 0;

                ticket.sale_contents.forEach(function(sale_content) {
                    if (sale_content.status === 'active') {
                        count++;
                    }
                });

                if ('wastage' in ticket) {
                    ticket.wastage.forEach(function(wastage) {
                        if (wastage.date_expired) {
                            if (Date.now() > Date.parse(wastage.date_expired)) {
                                if (ticket.ticket_type === 'single') {
                                    count -= wastage.wastage_transfers.length;
                                }
                            }
                            else {
                                count += wastage.spaces;
                                count -= wastage.wastage_transfers.length;
                            }
                        }
                        else {
                            count += wastage.spaces;
                            count -= wastage.wastage_transfers.length;
                        }
                    });
                }
                if ('received_wastage_transfers' in ticket) {
                    count += ticket.received_wastage_transfers.length;
                }
                return count;
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketModeView.vue?97ee0bc8